module.exports = __WEBPACK_EXTERNAL_MODULE_1__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"js-data","commonjs":"js-data","commonjs2":"js-data","root":"JSData"}
// module id = 1
// module chunks = 0